module.exports = __webpack_public_path__ + "static/media/U1-T1-10B.f28a2298.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T1-10B.svg
// module id = 604
// module chunks = 0